"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUniqueId = void 0;
const react_1 = require("react");
// @ts-ignore
const uuid_1 = require("uuid");
/**
 * Hook that returns unique id which is persistent during whole component lifecycle
 */
const useUniqueId = (staticId) => (0, react_1.useMemo)(() => (staticId === undefined ? (0, uuid_1.v4)() : staticId), [staticId]);
exports.useUniqueId = useUniqueId;
//# sourceMappingURL=useUniqueId.js.map